"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpTable = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const table_cell_1 = require("./table-cell");
const table_html_1 = __importDefault(require("./table.html"));
let ItpTable = class ItpTable extends vue_1.default {
    tableColumns;
    tableRows;
    rows;
    columns;
    bordered;
    size;
    headerVariant;
    onRowsChanged() {
        this.tableColumns = this.getTableColumns();
        this.tableRows = this.getTableRows();
    }
    onColumnsChanged() {
        this.tableColumns = this.getTableColumns();
        this.tableRows = this.getTableRows();
    }
    data() {
        return {
            tableColumns: this.getTableColumns(),
            tableRows: this.getTableRows()
        };
    }
    get className() {
        return [
            'table',
            `table-${this.size}`,
            {
                'table-bordered': this.bordered
            }
        ];
    }
    get theadClassName() {
        if (this.headerVariant) {
            return `thead-${this.headerVariant}`;
        }
    }
    getTableColumns() {
        return _.map(this.columns, (col, i) => ({
            ...col,
            className: this.getColumnClassName(col)
        }));
    }
    getTableRows() {
        return _.map(this.rows, (row, i) => ({
            rowIndex: i,
            cells: this.getRowCells(row),
            className: null
        }));
    }
    getRowCells(rowData) {
        return _.map(this.columns, (column, i) => ({
            cellIndex: i,
            column,
            rowData,
            value: this.getCellValue(column, rowData),
            className: this.getCellClassName(column, rowData)
        }));
    }
    getCellValue(column, row) {
        const value = _.get(row, column.field);
        if (column.type &&
            this.$options &&
            this.$options.filters &&
            _.isFunction(this.$options.filters[column.type])) {
            return this.$options.filters[column.type](value);
        }
        return value;
    }
    getColumnClassName(column) {
        if (!this.bordered) {
            return ['text-center', 'border-top-0'];
        }
        return 'text-center';
    }
    getCellClassName(column, row) {
        const result = [];
        if (_.isString(row['$rowClass'])) {
            result.push(row['$rowClass']);
        }
        if (column.textAlign) {
            result.push(`text-${column.textAlign}`);
        }
        return result;
    }
};
exports.ItpTable = ItpTable;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Array)
], ItpTable.prototype, "rows", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Array)
], ItpTable.prototype, "columns", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true }),
    __metadata("design:type", Boolean)
], ItpTable.prototype, "bordered", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'sm' }),
    __metadata("design:type", String)
], ItpTable.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'light' }),
    __metadata("design:type", String)
], ItpTable.prototype, "headerVariant", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rows'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpTable.prototype, "onRowsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('columns'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpTable.prototype, "onColumnsChanged", null);
exports.ItpTable = ItpTable = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: table_html_1.default,
        components: { ItpTableCell: table_cell_1.ItpTableCell }
    })
], ItpTable);
//# sourceMappingURL=table.js.map